const CashInStatus = {
  Success: "success",
  Pending: "pending",
  Failed: "failed",
  Expired: "expired",
};

export default CashInStatus;
